












































































import type { PropType } from "vue"
import type { stadium_ground_price } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import AddGroundPrice from "@/views/invest/detail/form/add_stadium_ground_price.vue"
import GroundPriceTable from "@/views/stadium_ground/stadium_ground_price_table.vue"

export default Vue.extend({
  name      : "StadiumGroundPrice",
  components: { AddGroundPrice, GroundPriceTable },
  props     : {
    id        : { type: String, required: true },
    stadium_id: { type: String, required: true },
    editable  : { type: Boolean, required: true },
    form      : { type: Object as PropType<stadium_ground_price> },
    correct   : { type: Object, default() { return {} } },
    show      : { type: Object,
      default() {
        return {
          all              : true,
          is_half_time     : -1,
          is_people_bill   : -1,
          business_time    : true,
          business_time_new: true,
          origin_price     : true,
          new_price        : true
        }
      }
    },
  },
  data() {
    return {
      is_half_time  : false,
      is_people_bill: false,
      origin        : [] as Array<any>,
      new_time      : [] as Array<any>,
      data          : {} as stadium_ground_price,
      change        : {} as any,
      days          : { 1: "周一", 2: "周二", 3: "周三", 4: "周四", 5: "周五", 6: "周六", 0: "周日" },
      prices        : [] as any,
      new_price     : [] as any
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.data, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const data = this.$deep_copy(this.form)
        this.origin = []
        for (const v of data.business_time) {
          this.origin.push(v.split(","))
        }
        for (const v of data.business_time_new) {
          this.new_time.push(v.split(","))
        }
        this.is_half_time = data.is_half_time == "1"
        this.is_people_bill = data.is_people_bill == "1"
        this.data = data
        const table = this.$refs.ground_price_table as any
        table.init()
      })
    },
    async change_half_time() {
      this.is_half_time      = !this.is_half_time
      this.data.is_half_time = this.is_half_time ? "1" : "0"
    },
    async change_people_bill() {
      this.is_people_bill      = !this.is_people_bill
      this.data.is_people_bill = this.is_people_bill ? "1" : "0"
    },
    add_origin() {
      this.$nextTick(() => {
        const add_ground_price = this.$refs.add_ground_price as any
        add_ground_price.open("原营业时间", 1, this.origin)
      })
    },
    add_new() {
      this.$nextTick(() => {
        const add_ground_price = this.$refs.add_ground_price as any
        add_ground_price.open("新增营业时间", 2, this.new_time)
      })
    },
    add_price(data: any) {
      this.prices.push(data)
    },
    async reset(t: number) {
      this.$confirm({
        content: "确定删除所有已添加片场价格，进行重新添加价格？",
        onOk: async () => {
          const params = { stadium_id: this.stadium_id, type: t }
          const res = await this.$store.dispatch("stadium/resetStadiumPrice", params);
          if (res.Code == 200) this.$success({ content: "重置成功" })
          else this.$error({ content: res.Message })
        }
      })
    },
    submit() {
      const params = this.$deep_copy(this.data)
      params.estimate_id = this.id
      params.prices = this.$deep_copy(this.prices)
      if (this.prices.length > 0) params.prices = this.prices
      console.log("modify:", params)
      this.$emit("modify", params)
    },
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          if (!this.correct.id) this.submit()
          this.change = this.$deep_copy(this.correct)
        })
      },
      deep   : true
    },
    prices: {
      handler() {
        this.$nextTick(() => {
          if (!this.correct.id) this.submit()
          this.change = this.$deep_copy(this.correct)
          console.log("Change Prices:", this.prices)
        })
      },
      deep   : true
    }
  }
})
